import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AddressResponse } from '@modelUser/address-response.model';
import {environment} from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(
    private httpClient: HttpClient
  ) {}


  // grenoble
  checkLicenseNumbersUniqueness(mobilityAccountId: number, licenseNumber: string): Observable<Boolean> {
    return this.httpClient.get<boolean>(
      environment.api.mobilityUrl +
        '/v1/mobilityAccounts/'+mobilityAccountId+'/registrationPlate/check?registrationPlate=' +
        licenseNumber,
      {
        headers: new HttpHeaders({
          'x-apikey': environment.api.apikey
        })
      }
    );
  }



}
